function Dice() {
    return (
      <div className="App">
        Dice
      </div>
    );
  }
  
  export default Dice;